import {IssueViewerContextProvider} from '@github-ui/issue-viewer/IssueViewerContextProvider'
import type React from 'react'
import {Suspense} from 'react'
import {NavigationContextProvider} from './contexts/NavigationContext'
import {QueryContextProvider} from './contexts/QueryContext'
import {useFeatureFlags} from '@github-ui/react-core/use-feature-flag'

type AppProps = {children?: React.ReactNode}

export function App({children}: AppProps) {
  const {issues_primer_portal} = useFeatureFlags()

  return (
    <NavigationContextProvider>
      <QueryContextProvider>
        <IssueViewerContextProvider>
          {issues_primer_portal && (
            <div role="region" id="__primerPortalRoot__" style={{zIndex: 15, position: 'absolute', width: '100%'}} />
          )}
          <Suspense fallback={<span>Loading...</span>}>{children}</Suspense>
        </IssueViewerContextProvider>
      </QueryContextProvider>
    </NavigationContextProvider>
  )
}

try{ App.displayName ||= 'App' } catch {}